import { render, staticRenderFns } from "./ordersSearch.vue?vue&type=template&id=009f3046"
import script from "./ordersSearch.vue?vue&type=script&lang=js"
export * from "./ordersSearch.vue?vue&type=script&lang=js"
import style0 from "./ordersSearch.vue?vue&type=style&index=0&id=009f3046&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports